import { NgModule, APP_INITIALIZER } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';

import { EnvLoadService } from './env-load.service';

export function init_app(envLoadService: EnvLoadService) {
    return () => envLoadService.initializeApp();
}

export function setEnv(envLoadService: EnvLoadService) {
    return () => envLoadService.setEnv();
}

@NgModule({
    imports: [HttpClientModule],
    providers: [
        EnvLoadService,
        /*{ provide: APP_INITIALIZER, useFactory: init_app, deps: [AppLoadService], multi: true },*/
        { provide: APP_INITIALIZER, useFactory: setEnv, deps: [EnvLoadService], multi: true }
    ]
})
export class EnvLoadModule { }



// WEBPACK FOOTER //
// ./src/app/env-load/env-load.module.ts